import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

export const useFilterOptionLabels = () => {
  const { t } = useTranslation();
  const quality_values = useSelector((state) => state.global_settings?.quality_system?.quality_values || []);

  const filterOptionsTitle = (filterKey) => t(`Filters.${filterKey}`).toUpperCase();

  const filterOptionsLabels = (filterTitle, allOptions = []) => {
    const qualitySource = allOptions.length ? allOptions : quality_values;
    const qualityValues = qualitySource.map((value) => t(`Quality.${value}`));

    if (filterTitle === 'density') return ['ACR A', 'ACR B', 'ACR C', 'ACR D'];
    if (filterTitle === 'quality') return qualityValues;
    if (filterTitle === 'modality')
      return [
        t('Filters.modality_mammo'),
        t('Filters.modality_tomo'),
        t('Filters.modality_pseudo_synthetic'),
      ];

    if (filterTitle === 'screening')
      return [t('Filters.screening_screening'), t('Filters.screening_diagnostic')];

    if (filterTitle === 'opacities')
      return [
        'BI-RADS 2',
        'BI-RADS 3',
        'BI-RADS 4',
        'BI-RADS 5',
        t('projections.lesionKnown'),
        t('Filters.diagnosis_lesions_no'),
      ];

    if (filterTitle === 'microcalc')
      return [
        t('projections.vessel'),
        'BI-RADS 2',
        'BI-RADS 3',
        'BI-RADS 4',
        'BI-RADS 5',
        t('Filters.diagnosis_lesions_no'),
      ];

    if (filterTitle === 'postop') return [t('Filters.postop_operated'), t('Filters.postop_not_operated')];
    if (filterTitle === 'multiExams') return t('Filters.multi_exams');
    if (filterTitle === 'multiCaptures') return t('Filters.multi_captures');
    if (filterTitle === 'analyzed_3d') return t('Filters.analyzed_3d');
    if (filterTitle === 'annotatedOnly') return t('Filters.reannotated');
    if (filterTitle === 'confirmedOnly') return t('Filters.confirmed');

    if (filterTitle === 'revision')
      return [
        t('Filters.not_confirmed'),
        t('Filters.confirmed_density'),
        t('Filters.confirmed_quality'),
        t('Filters.confirmed_opacities'),
        t('Filters.confirmed_microcalc'),
      ];

    if (filterTitle === 'risk')
      return [t('Filters.low_risk'), t('Filters.moderate_risk'), t('Filters.high_risk')];

    return Array.isArray(allOptions) ? allOptions.map((value) => String(value)) : [];
  };

  return {
    filterOptionsTitle,
    filterOptionsLabels,
  };
};
